export { DMS_MODULE } from '../constants';
export { SDA_VIN_PREFIX, DELKA_VIN } from '@/modules/kartoteka/vozidlo/constants';

export const CRUMB_LABEL_KEY = 'grdVozidloZakaznik';
export const NAME = 'HromadnaKorespondence';

export const SDA_FOR_VIN_COUNT = 4;
